module.exports = __webpack_public_path__ + "static/img/4.2c907fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/17/sp/4.png
// module id = oIXg
// module chunks = 0